import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { PageNames } from 'src/app/configs/page-names.enum';
import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import {
  CustomResultOfGetCampaignByIdDto,
  GetEnumValuesDto,
  SendTypes,
} from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { CampaignInfoService } from 'src/app/core/services/campaign-info.service';
import { ConsoleService } from 'src/app/core/services/console.service';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { GetCampaignsWithPaginationDto } from './../../../core/api/models/get-campaigns-with-pagination-dto';
import { PaginatedListOfGetCampaignsWithPaginationDto } from './../../../core/api/models/paginated-list-of-get-campaigns-with-pagination-dto';
import { CampaignsService } from './../../../core/api/services/campaigns.service';

@Component({
  selector: 'app-campaigns',
  templateUrl: './campaigns.component.html',
  standalone: false,
})
export class CampaignsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.campaigns;

  modelWithPagination$: Observable<PaginatedListOfGetCampaignsWithPaginationDto>;
  items$: Observable<Array<GetCampaignsWithPaginationDto>>;

  SendSubTypesEnumValues: GetEnumValuesDto[] = [];
  SendTypesEnumValues: GetEnumValuesDto[] = [];
  get SendTypes() {
    return SendTypes;
  }
  get SendSubTypes() {
    return SendTypes;
  }

  lastSelectedSendPageName: string = '';

  //#endregion

  constructor(
    protected currentService: CampaignsService,
    public dynamicTabService: DynamicTabService
  ) {
    super();
  }

  ngOnInit(): void {
    try {
      if (window.location.search.includes(QueryStringTypesEnum.Campaign_key)) {
        let params = this.routingState.parseQueryString();
        for (const [key, value] of Object.entries(params)) {
          if (key == QueryStringTypesEnum.Campaign_key) this.onSelect(+value);
        }
        this.location.go(window.location.pathname);
      }
      super.ngOnInit();
      this.getUserState();
      this.pageConfig.showAddBtn = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('SendSubTypes').subscribe(
      (values) => (this.SendSubTypesEnumValues = values)
    );
    this.getEnumValuesApi('SendTypes').subscribe(
      (values) => (this.SendTypesEnumValues = values)
    );
  }

  configTableColumns(): void {
    this.tableColumns = [
      {
        title: this.localizer.id,
        name: 'id',
        hasSearch: true,
        type: 'number',
        noNumberSeparator: true,
      },
      { title: this.localizer.title, name: 'title', hasSearch: true },
      { title: this.localizer.smsText, name: 'smsText', hasSearch: true },
      {
        title: this.localizer.organization,
        name: 'organizationName',
        hasSearch: true,
      },
      {
        title: this.localizer.sendType,
        name: 'sendType',
        hasSearch: true,
        type: 'enum',
        enumName: 'SendTypes',
      },
      {
        title: this.localizer.sendSubType,
        name: 'sendSubType',
        hasSearch: true,
        type: 'enum',
        enumName: 'SendSubTypes',
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  //Get All
  getPaginationApi(): Observable<any> {
    return this.currentService.campaignsGetCampaignsWithPagination({
      body: this.getBaseModelWithPaginationParams(),
    });
  }

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .campaignsGetCampaignById({ CampaignId: id })
      .pipe(this.basePipeOperators())
      .subscribe((res: CustomResultOfGetCampaignByIdDto) => {
        try {
          ConsoleService.info('res', res);
          // CampaignInfoService.lastCampaignInfo$.next(res);
          CampaignInfoService.lastCampaignInfo = res.data;
          this.selectSendTypePageName(res.data?.sendType);
        } catch (error) {
          this.loggerService.logError(
            this.tagName,
            error,
            EventTypes.sendingSystem
          );
        }
      });
  }

  //Delete
  baseDeleteApi(id: number) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = id;

    this.currentService
      .campaignsDelete({ id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDeleteObserver);
  }

  //#endregion

  onSelect(id: number) {
    this.baseGetByIdApi(id);
  }

  selectSendTypePageName(sendType: SendTypes) {
    try {
      switch (sendType) {
        case SendTypes.Single:
          this.lastSelectedSendPageName = 'sendSMS';
          break;
        case SendTypes.Phonebook:
          this.lastSelectedSendPageName = 'sendSMSWithPhonebook';
          break;
        case SendTypes.Bulk2:
          this.lastSelectedSendPageName = 'sendBulkSMS2';
          break;
        case SendTypes.Dynamic:
          this.lastSelectedSendPageName = 'dynamicSendSms';
          break;
        case SendTypes.P2P:
          this.lastSelectedSendPageName = 'sendP2pSms';
          break;
        case SendTypes.Smart:
          this.lastSelectedSendPageName = 'smartSmsRequestConfirmData';
          break;
        case SendTypes.Club:
          this.lastSelectedSendPageName = 'sendWhiteMessage';
          break;
        case SendTypes.Bulk:
          this.lastSelectedSendPageName = 'sendBulkSMS';
          break;

        default:
          break;
      }

      this.openPage(this.lastSelectedSendPageName);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  openPage(tabName: string) {
    try {
      this.dynamicTabService.setNewTab('');
      this.dynamicTabService.setNewTab(tabName);
      this.dynamicTabService.setActiveTab(tabName);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }
}
